<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>攻击配置</span>
        </div>

        <el-form class="demo-form-inline">
          <el-form-item label="好友被打次数上限">
            <el-input v-model.number="formData.rand_friend_limit" style="width: 200px;" placeholder="好友被打次数上限" />
          </el-form-item>
          <el-form-item label="打好友的权重">
            <el-input v-model.number="formData.friend_weight" style="width: 200px;" placeholder="打好友的权重" />
          </el-form-item>
          <el-form-item label="最小可打等级">
            <el-input v-model.number="formData.minLv" style="width: 200px;" placeholder="最小可打等级" />
          </el-form-item>
          <el-form-item label="最大可达次数">
            <el-input v-model.number="formData.maxLimit" style="width: 200px;" placeholder="最大可达次数" />
          </el-form-item>
          <el-form-item label="被打对象等级范围">
            <el-input v-model.number="formData.user_level" style="width: 200px;" placeholder="被打对象等级范围" />
          </el-form-item>
          <el-form-item label="机器人盾牌权重">
            <el-input v-model.number="formData.robot_shield_weight" style="width: 100px;" placeholder="机器人盾牌权重" />
          </el-form-item>
          <el-button v-permisaction="['config:card-process:save']" type="primary" @click="onSubmit()">保存</el-button>
        </el-form>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getCommonCfg, updateCommonCfg } from '@/api/config/common-cfg'

export default {
  name: 'AttackConfig',
  data() {
    return {
      formData:
        {
          'rand_friend_limit': 0,
          'friend_weight': 0,
          'grow_weight': 0,
          'maxLimit': 0,
          'minLv': 0,
          'user_level': 0,
          'robot_shield_weight': 0
        }
    }
  },
  created() {
    this.getTables()
  },
  methods: {
    onSubmit() {
      const data = JSON.stringify(this.formData)
      console.log(data)
      if (data.length < 1) {
        this.msgError('没有需要提交的数据')
        return
      }
      updateCommonCfg({ name: 'TIGER_ATTACK_CONFIG', data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables() {
      getCommonCfg({ name: 'TIGER_ATTACK_CONFIG' }).then(res => {
        if (res.code === 200) {
          this.formData = res.data
        } else {
          this.msgError(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
